(() => {
  if (window.lrFooterLoaded) return;
  window.lrFooterLoaded = true;
  const instances = new Map();
  function init(scope) {
    scope.querySelectorAll('[data-lr-footer]').forEach(footer => {
      if (instances.has(footer)) return;
      const controller = new AbortController();
      const desktop = matchMedia('(min-width: 750px)');
      const groups = [...footer.querySelectorAll('[data-lr-footer-links]')];
      const sync = () => groups.forEach(group => { group.open = desktop.matches; });
      groups.forEach(group => group.querySelector('summary').addEventListener('click', event => { if (desktop.matches) event.preventDefault(); }, {signal: controller.signal}));
      desktop.addEventListener('change', sync, {signal: controller.signal});
      footer.dataset.enhanced = '';
      sync();
      instances.set(footer, () => controller.abort());
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const group = event.target.closest('[data-lr-footer-links]');
    if (group) group.open = true;
  });
  document.addEventListener('shopify:section:unload', event => {
    for (const [footer, cleanup] of instances) if (event.target.contains(footer)) { cleanup(); instances.delete(footer); }
  });
})();
